import { Field } from "formik";
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ControlLabel } from "react-bootstrap";
import FormikFormControl from './FormikFormControl';

class FormikInputControl extends Component {
  static propTypes = {
    fieldLabel: PropTypes.string.isRequired,
    fieldName: PropTypes.string.isRequired,
    errors: PropTypes.any.isRequired,
    touched: PropTypes.any.isRequired
  }

  render () {
    const { fieldName, fieldLabel } = this.props
    const fieldType = this.props.fieldType || 'text'
    return (
      <FormikFormControl {...this.props}>
        <ControlLabel>{fieldLabel}</ControlLabel>
        <Field type={fieldType} name={fieldName} className="form-control input-sm" placeholder={this.props.placeholder} />
      </FormikFormControl>)
  }
}

export default FormikInputControl